import { PayloadAction } from "@reduxjs/toolkit";
import { RequestStatus } from "types";
import { Template, TemplateState } from "../../types/Template";

const setSaveTemplateRequestStatus = (
  state: TemplateState,
  action: PayloadAction<RequestStatus>
) => {
  state.saveTemplateRequestStatus = action.payload;
};

const setTemplates = (
  state: TemplateState,
  action: PayloadAction<Template[]>
): void => {
  state.templates = action.payload;
};

const reducers = {
  setSaveTemplateRequestStatus,
  setTemplates,
};

export default reducers;
